export default "__VITE_ASSET__cf528a1b__"